import React from "react";
import { 
    BodyCard,
    HeadCard,
    BottomCard,
    StyledPopup } from "./style";
import { useSelector} from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { Close } from "../MainModal/Close";
import { Card } from '../../theme/theme'
import ModalButton from '../ModalButton'
import { language } from "../../utils/language";




const AlertSelectCity = (props: any) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    return (
        <>
            <StyledPopup 
                ref={props.refData}
                trigger={
                    <div>
                        
                    </div>
                } position="bottom center" className="containerPopup">
                {(close: any) => (
                    <Card>
                        <HeadCard {...props}>
                            <div>
                                {language[homeState.default_language]["optionSend"]}
                            </div> 
                            <Close onClick={close} color={homeState.color}>
                                {}
                            </Close>
                        </HeadCard>      
                        <BodyCard>
                            {language[homeState.default_language]["messageDeliverySelected"]}
                        </BodyCard>
                        <BottomCard>
                            <ModalButton color={homeState.color} secondary={false} className='ml-2' onClick={close}>{language[homeState.default_language]["ok"]}</ModalButton>
                        </BottomCard>
                    </Card>
                )}
            </StyledPopup>
        </>
    );
};

export default AlertSelectCity;